(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_deab66c"] && !Shopify.designMode) return;
  try {
    (function () {
    const giveAwayForms = document.querySelectorAll('.ai-giveaway-form');

    giveAwayForms.forEach((form) => {
      const button = form.querySelector('button');
      const innerForm = form.querySelector('.ai-giveaway-form__form');

      button.addEventListener(
        'click',
        () => {
          innerForm.classList.remove('hidden');
          button.classList.add('hidden');
        },
        { once: true }
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
